export const quotes = [
	{
		"quote": "We stand vigilant, for the Emperor watches over us.",
		"author": "Lord Commander Dante of the Blood Angels"
	},
	{
		"quote": "The Emperor's enemies shall wither in His righteous light.",
		"author": "Inquisitor Helena Karamazov"
	},
	{
		"quote": "By His will alone, we set the stars ablaze.",
		"author": "Captain Cato Sicarius of the Ultramarines"
	},
	{
		"quote": "Purity in duty, duty in service, service to the Emperor.",
		"author": "Sister Superior Amalia of the Adepta Sororitas"
	},
	{
		"quote": "The Emperor's will is eternal; His reign shall never falter.",
		"author": "Warmaster Macaroth of the Imperial Guard"
	},
	{
		"quote": "In His divine wisdom, we find our path through the stars.",
		"author": "Farseer Eldrad Ulthran, in a captured transmission"
	},
	{
		"quote": "To falter is to fail, to fail is to damnation.",
		"author": "Chaplain Grimaldus of the Black Templars"
	},
	{
		"quote": "Through suffering, we find His embrace.",
		"author": "Apothecary Gideon of the Dark Angels"
	},
	{
		"quote": "No sacrifice too great, no heresy too small.",
		"author": "Inquisitor Czevak, Ordo Xenos"
	},
	{
		"quote": "His gaze fortifies our spirits, His wrath undoes His foes.",
		"author": "Librarian Tigurius of the Ultramarines"
	},
	{
		"quote": "No blade can cleave our faith, for we are His eternal guardians.",
		"author": "Knight Commander Pask of the Imperial Guard"
	},
	{
		"quote": "His word, our command; His gaze, our path.",
		"author": "Phoenix Lord Jain Zar of the Howling Banshees, in a taunting message"
	},
	{
		"quote": "Under His immortal watch, we shall not falter.",
		"author": "Commander Farsight, in a reluctant acknowledgement"
	},
	{
		"quote": "In His sacred name, our enemies shall be undone.",
		"author": "Canoness Veridyan of the Adepta Sororitas"
	},
	{
		"quote": "Vigilance and purity shall shield us from corruption.",
		"author": "Grand Master Voldus of the Grey Knights"
	},
	{
		"quote": "His word is law, His wrath, the crucible of victory.",
		"author": "Lord Castellan Creed of the Imperial Guard"
	},
	{
		"quote": "For the Emperor, we lay waste to the stars.",
		"author": "Chapter Master Calgar of the Ultramarines"
	},
	{
		"quote": "To serve Him is to bask in the eternal light of duty.",
		"author": "High Marshal Helbrecht of the Black Templars"
	},
	{
		"quote": "His foes shall perish, their ashes scattered to the void.",
		"author": "Tech-Priest Dominus Belisarius Cawl"
	},
	{
		"quote": "Upon the altar of battle, we sacrifice in His name.",
		"author": "Brother-Captain Stern of the Grey Knights"
	},
	{
		"quote": "In this damned galaxy, only His light keeps the darkness at bay.",
		"author": "Rogue Trader Elara Vanth"
	},
	{
		"quote": "To the Warp with the heretics and damn the traitors!",
		"author": "Commissar Holt of the Imperial Guard"
	},
	{
		"quote": "By the Emperor's golden balls, that's a lot of xenos!",
		"author": "Sergeant Lukas Bastonne"
	},
	{
		"quote": "If a xenos or traitor stands before me, they're already damned dead.",
		"author": "Brother-Sergeant Agathon of the Deathwatch"
	},
	{
		"quote": "Damnation waits for those who dare defy His will.",
		"author": "Canoness Selena of the Adepta Sororitas"
	},
	{
		"quote": "The galaxy's a shithole, but it's our shithole to defend in His name.",
		"author": "Colonel 'Iron Hand' Straken"
	},
	{
		"quote": "For every cursed step the enemy takes, we'll spill a sea of their damned blood.",
		"author": "Lord Solar Macharius"
	},
	{
		"quote": "When you gaze upon the abyss and the abyss curses back, remember the Emperor is with you.",
		"author": "Chaplain Cassius of the Ultramarines"
	},
	{
		"quote": "By the Emperor's wrath, I'll send every last one of those bastards screaming into the void.",
		"author": "Captain Tycho of the Blood Angels"
	},
	{
		"quote": "There's no hell like the one we're in, but by His grace, we'll conquer it.",
		"author": "Kaldor Draigo, Supreme Grand Master of the Grey Knights"
	},
	{
		"quote": "For every curse uttered against Him, we bring a thousand years of retribution.",
		"author": "Inquisitor Ravenor"
	},
	{
		"quote": "The galaxy's full of damned souls and heretical scum. Time to do some cleansing.",
		"author": "Torquemada Coteaz, Ordo Malleus"
	},
	{
		"quote": "Trust in His guidance, and damn any who stand against us.",
		"author": "Chapter Master Shrike of the Raven Guard"
	},
	{
		"quote": "We've been through hell, but as long as we draw breath, the Emperor's enemies will know damnation.",
		"author": "Sergeant Harker of the Catachan Jungle Fighters"
	},
	{
		"quote": "They can curse His name, but in the end, every knee shall bow before His might.",
		"author": "Cardinal Boros of the Ecclesiarchy"
	},
	{
		"quote": "By His righteous fury, I'll see this damned galaxy purged of every traitor.",
		"author": "Azrael, Supreme Grand Master of the Dark Angels"
	},
	{
		"quote": "Curse their eyes, the xenos think they know fear? We'll show them true terror.",
		"author": "Captain Lysander of the Imperial Fists"
	},
	{
		"quote": "If there's one thing I hate more than a damned heretic, it's two damned heretics.",
		"author": "Commissar Yarrick"
	},
	{
		"quote": "The damned and the treacherous shall feel His wrath, one bolt round at a time.",
		"author": "Sergeant Telion of the Ultramarines"
	},
	{
		"quote": "They may curse us, loathe us, fight us - but in His name, we shall be the last ones standing.",
		"author": "Marshal Helborg of the Adeptus Arbites"
	},
	{
		"quote": "A coward's only reward is to live in fear another day.",
		"author": ""
	},
	{
		"quote": "A dagger in the dark is worth a thousand swords at dawn.",
		"author": ""
	},
	{
		"quote": "A pity it is that we can die but once in the Emperor's service.",
		"author": ""
	},
	{
		"quote": "A small mind is a tidy mind.",
		"author": ""
	},
	{
		"quote": "A suspicious mind is a healthy mind.",
		"author": ""
	},
	{
		"quote": "A swift execution is worth a hundred interrogations.",
		"author": ""
	},
	{
		"quote": "Abhor the mutant.",
		"author": ""
	},
	{
		"quote": "Abhor the Night, it is the Light that Endures.",
		"author": ""
	},
	{
		"quote": "Abhor the xenos.",
		"author": ""
	},
	{
		"quote": "Abhorrence is a gift; use it well.",
		"author": ""
	},
	{
		"quote": "Aim without mercy.",
		"author": ""
	},
	{
		"quote": "Aim true and strike deep.",
		"author": ""
	},
	{
		"quote": "All mortal life is folly that does not feed the spirit.",
		"author": ""
	},
	{
		"quote": "An informed opinion must be dismissed with the resolute certainty of faith.",
		"author": ""
	},
	{
		"quote": "An open mind is like a fortress with its gates unbarred and unguarded.",
		"author": ""
	},
	{
		"quote": "Arise for vengeance.",
		"author": ""
	},
	{
		"quote": "Be not merciful.",
		"author": ""
	},
	{
		"quote": "Be steadfast in defense.",
		"author": ""
	},
	{
		"quote": "Be the Emperor's reaper.",
		"author": ""
	},
	{
		"quote": "Be thou the scourge of traitors.",
		"author": ""
	},
	{
		"quote": "Become righteousness made manifest.",
		"author": ""
	},
	{
		"quote": "Become vengeance.",
		"author": ""
	},
	{
		"quote": "Beware the corruption of men's souls.",
		"author": ""
	},
	{
		"quote": "Beyond the Emperor's light lies only despair.",
		"author": ""
	},
	{
		"quote": "Blessed are the intolerant.",
		"author": ""
	},
	{
		"quote": "Blessed are the merciless.",
		"author": ""
	},
	{
		"quote": "Blessed are they without introspection, for they shall know no doubt.",
		"author": ""
	},
	{
		"quote": "Blessed be the slaughterer of heretics.",
		"author": ""
	},
	{
		"quote": "Blessed be the subjugator.",
		"author": ""
	},
	{
		"quote": "Blessed be the vengeful God, for He is the only true God.",
		"author": ""
	},
	{
		"quote": "Blessed be the vengeful.",
		"author": ""
	},
	{
		"quote": "Blessed is the mind too small for doubt.",
		"author": ""
	},
	{
		"quote": "Blessed be thy aim.",
		"author": ""
	},
	{
		"quote": "Blessed be thy fury.",
		"author": ""
	},
	{
		"quote": "Blood for the Blood God! Skulls for the Skull Throne.",
		"author": ""
	},
	{
		"quote": "By the way of their death shall we know them.",
		"author": ""
	},
	{
		"quote": "By your scars and deeds shall you be judged.",
		"author": ""
	},
	{
		"quote": "Carry the Will of the Emperor like a torch in the darkness.",
		"author": ""
	},
	{
		"quote": "Carry your scars with honour.",
		"author": ""
	},
	{
		"quote": "Cleanse the mutant; burn the heretic; purge the xenos.",
		"author": ""
	},
	{
		"quote": "Cleave to the Emperor's light.",
		"author": ""
	},
	{
		"quote": "Complaining of thy lot is the first step on the Road to Damnation.",
		"author": ""
	},
	{
		"quote": "Condemn the damned to their reward.",
		"author": ""
	},
	{
		"quote": "Courage is the Emperor's gift.",
		"author": ""
	},
	{
		"quote": "Curse the traitor, condemn the weak.",
		"author": ""
	},
	{
		"quote": "Death brings peace to the unfaithful.",
		"author": ""
	},
	{
		"quote": "Despise the weak, for they shall flock to the call of the renegade.",
		"author": ""
	},
	{
		"quote": "Destroy the corruption wherever it is found.",
		"author": ""
	},
	{
		"quote": "Do not shy the hopeless fight, for endeavour is its own reward.",
		"author": ""
	},
	{
		"quote": "Doubt not the Emperor's wrath.",
		"author": ""
	},
	{
		"quote": "Doubt not thy strength whilst faith prevails.",
		"author": ""
	},
	{
		"quote": "Duty demands sacrifice.",
		"author": ""
	},
	{
		"quote": "Duty first, duty last.",
		"author": ""
	},
	{
		"quote": "Duty is vital, understanding is not.",
		"author": ""
	},
	{
		"quote": "Emperor guide thy aim.",
		"author": ""
	},
	{
		"quote": "Endure the present, so those who follow may continue your endeavours.",
		"author": ""
	},
	{
		"quote": "Even the greatest hero is but a ripple on the surface of space.",
		"author": ""
	},
	{
		"quote": "Exist for the Emperor.",
		"author": ""
	},
	{
		"quote": "Facts are chains that bind perception and fetter truth.",
		"author": ""
	},
	{
		"quote": "Faith conquers all.",
		"author": ""
	},
	{
		"quote": "Faith needs no excuse.",
		"author": ""
	},
	{
		"quote": "Fear not obliteration, for it awaits us all.",
		"author": ""
	},
	{
		"quote": "Fear the wrath of the righteous.",
		"author": ""
	},
	{
		"quote": "Foolish are those who fear nothing, yet claim to know everything.",
		"author": ""
	},
	{
		"quote": "For every enemy without, there are a hundred within.",
		"author": ""
	},
	{
		"quote": "Forget not; forgive nothing.",
		"author": ""
	},
	{
		"quote": "Forgiveness is a crime punishable by death.",
		"author": ""
	},
	{
		"quote": "Forgiveness is punishable by death.",
		"author": ""
	},
	{
		"quote": "From duty and death there can be no respite.",
		"author": ""
	},
	{
		"quote": "Gird thyself with the Emperor's light.",
		"author": ""
	},
	{
		"quote": "Guard Humanity; fear the Enemy Beyond.",
		"author": ""
	},
	{
		"quote": "Guard thy soul against disorder.",
		"author": ""
	},
	{
		"quote": "Happiness is a delusion of the Weak.",
		"author": ""
	},
	{
		"quote": "Hasten the damned to their reward.",
		"author": ""
	},
	{
		"quote": "He knows what lies in the darkness, and fears it not.",
		"author": ""
	},
	{
		"quote": "Heed not the whispers of the faithless.",
		"author": ""
	},
	{
		"quote": "Heed the Word of the Emperor.",
		"author": ""
	},
	{
		"quote": "Here be the doom of mutants.",
		"author": ""
	},
	{
		"quote": "Here endeth thy lesson.",
		"author": ""
	},
	{
		"quote": "Honour the craft of death.",
		"author": ""
	},
	{
		"quote": "Honour thy Emperor.",
		"author": ""
	},
	{
		"quote": "Honour thy oaths, honour thy Emperor.",
		"author": ""
	},
	{
		"quote": "Honour thy regiment.",
		"author": ""
	},
	{
		"quote": "Honour thy weapon.",
		"author": ""
	},
	{
		"quote": "Honour your duty.",
		"author": ""
	},
	{
		"quote": "Honour, duty and obedience.",
		"author": ""
	},
	{
		"quote": "Hope is superfluous.",
		"author": ""
	},
	{
		"quote": "Hope is the first step on the road to disappointment.",
		"author": ""
	},
	{
		"quote": "I bringeth death.",
		"author": ""
	},
	{
		"quote": "I speak with tongues of flame.",
		"author": ""
	},
	{
		"quote": "If you see no signs of sedition, you aren't looking hard enough.",
		"author": ""
	},
	{
		"quote": "Ignorance is thy best defense.",
		"author": ""
	},
	{
		"quote": "Imperialis Dominatus.",
		"author": ""
	},
	{
		"quote": "Impurity of deed or thought is treason.",
		"author": ""
	},
	{
		"quote": "In Terra's light we serve.",
		"author": ""
	},
	{
		"quote": "Innocence proves nothing.",
		"author": ""
	},
	{
		"quote": "Intolerance is a blessing.",
		"author": ""
	},
	{
		"quote": "It is an honour to bleed for the Emperor.",
		"author": ""
	},
	{
		"quote": "Justice allows no doubt.",
		"author": ""
	},
	{
		"quote": "Keep the faith, kill the foe.",
		"author": ""
	},
	{
		"quote": "Kill the heretic with fervour.",
		"author": ""
	},
	{
		"quote": "Knowledge brings us closer to annihilation.",
		"author": ""
	},
	{
		"quote": "Knowledge is power, guard it well.",
		"author": ""
	},
	{
		"quote": "Lack of faith is tantamount to treason.",
		"author": ""
	},
	{
		"quote": "Let faith trample reason.",
		"author": ""
	},
	{
		"quote": "Let no foe stand before you.",
		"author": ""
	},
	{
		"quote": "Let not thy hate be conquered by fear.",
		"author": ""
	},
	{
		"quote": "Let thy weapon be zeal, and thy armour contempt.",
		"author": ""
	},
	{
		"quote": "Life is fleeting; duty is eternal.",
		"author": ""
	},
	{
		"quote": "Life is measured not in years, but by the deeds of the faithful.",
		"author": ""
	},
	{
		"quote": "Life is the Emperor's currency, spend it well.",
		"author": ""
	},
	{
		"quote": "Mankind stands upon the shoulders of the martyred.",
		"author": ""
	},
	{
		"quote": "Mercy is a disease; intolerance is the cure.",
		"author": ""
	},
	{
		"quote": "Narrow minds are faithful minds.",
		"author": ""
	},
	{
		"quote": "Night descends, yet still the Emperor's light shows the way.",
		"author": ""
	},
	{
		"quote": "No man died in the Emperor's service that died in vain.",
		"author": ""
	},
	{
		"quote": "Only in death does duty end.",
		"author": ""
	},
	{
		"quote": "Only the coward seeks compromise.",
		"author": ""
	},
	{
		"quote": "Pass judgement without mercy.",
		"author": ""
	},
	{
		"quote": "Persecute, punish, persist.",
		"author": ""
	},
	{
		"quote": "Praise be the Emperor, who teaches us the ways of war.",
		"author": ""
	},
	{
		"quote": "Praise the Emperor.",
		"author": ""
	},
	{
		"quote": "++REDACTED BY ORDER OF THE INQUISITION++.",
		"author": ""
	},
	{
		"quote": "Reject peace for the lie that it is.",
		"author": ""
	},
	{
		"quote": "Rejoice in repentance.",
		"author": ""
	},
	{
		"quote": "Rejoice in thy service.",
		"author": ""
	},
	{
		"quote": "Retribution is your birthright.",
		"author": ""
	},
	{
		"quote": "Scourge the stars in the Emperor's name.",
		"author": ""
	},
	{
		"quote": "Seek for yourself a death worthy of remembrance.",
		"author": ""
	},
	{
		"quote": "Slay the impure and sanctify the faithful.",
		"author": ""
	},
	{
		"quote": "Smite all who oppose the Emperor.",
		"author": ""
	},
	{
		"quote": "Smite all who would besmirch the Emperor's name.",
		"author": ""
	},
	{
		"quote": "Speak not the names of traitors.",
		"author": ""
	},
	{
		"quote": "Suffer no impurity.",
		"author": ""
	},
	{
		"quote": "The difference between heresy and treachery is ignorance.",
		"author": ""
	},
	{
		"quote": "The Emperor bears the weight of Mankind's ills.",
		"author": ""
	},
	{
		"quote": "The Emperor bestows upon us the gift of intolerance.",
		"author": ""
	},
	{
		"quote": "The Emperor commands, the Astra Militarum obeys.",
		"author": ""
	},
	{
		"quote": "The Emperor is all.",
		"author": ""
	},
	{
		"quote": "The Emperor knows, the Emperor is watching.",
		"author": ""
	},
	{
		"quote": "The Emperor protects.",
		"author": ""
	},
	{
		"quote": "The Emperor's justice is a beautiful thing.",
		"author": ""
	},
	{
		"quote": "The guilt of heresy weighs heavy on the soul.",
		"author": ""
	},
	{
		"quote": "The Imperium of Mankind shall never yield.",
		"author": ""
	},
	{
		"quote": "The mutant is guileful, trust it not.",
		"author": ""
	},
	{
		"quote": "The price of duty is high, but the rewards are eternal.",
		"author": ""
	},
	{
		"quote": "The righteous fear naught.",
		"author": ""
	},
	{
		"quote": "The same hammer that shatters the glass, forges the steel.",
		"author": ""
	},
	{
		"quote": "The seeds of heresy are planted in the minds of the enlightened.",
		"author": ""
	},
	{
		"quote": "The shield of faith is your best protection.",
		"author": ""
	},
	{
		"quote": "The traitor shall burn.",
		"author": ""
	},
	{
		"quote": "The traitor's hand lies closer than you think.",
		"author": ""
	},
	{
		"quote": "The truth is terrible to bear.",
		"author": ""
	},
	{
		"quote": "The victor lives in honour; the vanquished dies in shame.",
		"author": ""
	},
	{
		"quote": "The wage of negligence is utter destruction.",
		"author": ""
	},
	{
		"quote": "The weak shall be purged, the strong shall endure.",
		"author": ""
	},
	{
		"quote": "The Will of the Emperor is the might of the Imperium.",
		"author": ""
	},
	{
		"quote": "The wise have much to fear; the ignorant are blessed with courage.",
		"author": ""
	},
	{
		"quote": "The wise learn from the deaths of others.",
		"author": ""
	},
	{
		"quote": "There are no walls strong enough to protect the enemies of Mankind.",
		"author": ""
	},
	{
		"quote": "There is no being so foul as the traitor.",
		"author": ""
	},
	{
		"quote": "There is no fear in conviction.",
		"author": ""
	},
	{
		"quote": "There is no future without the Emperor's blessing.",
		"author": ""
	},
	{
		"quote": "There is only the Emperor.",
		"author": ""
	},
	{
		"quote": "There is purity of purpose in the faith of the just.",
		"author": ""
	},
	{
		"quote": "Thou art the hammer of the Emperor.",
		"author": ""
	},
	{
		"quote": "Thou shalt be remembered by thy deeds.",
		"author": ""
	},
	{
		"quote": "Thou shalt kill.",
		"author": ""
	},
	{
		"quote": "Thou shalt not yield.",
		"author": ""
	},
	{
		"quote": "Thy hand is justice.",
		"author": ""
	},
	{
		"quote": "Timidity begets indecision; indecision begets treachery.",
		"author": ""
	},
	{
		"quote": "To err is to invite retribution.",
		"author": ""
	},
	{
		"quote": "To relinquish contempt is capitulation.",
		"author": ""
	},
	{
		"quote": "To spare the traitor is to invite corruption.",
		"author": ""
	},
	{
		"quote": "To question is to doubt.",
		"author": ""
	},
	{
		"quote": "To question your master is to betray the Emperor.",
		"author": ""
	},
	{
		"quote": "To withdraw in disgust is not apathy.",
		"author": ""
	},
	{
		"quote": "Tolerance begets heresy.",
		"author": ""
	},
	{
		"quote": "True faith is blind and justified.",
		"author": ""
	},
	{
		"quote": "True wisdom is acceptance of the inevitable.",
		"author": ""
	},
	{
		"quote": "Trust only the Emperor.",
		"author": ""
	},
	{
		"quote": "Truth begets hatred.",
		"author": ""
	},
	{
		"quote": "Understanding weakens the will to act.",
		"author": ""
	},
	{
		"quote": "Victory belongs to the Emperor.",
		"author": ""
	},
	{
		"quote": "Victory needs no explanation; defeat allows none.",
		"author": ""
	},
	{
		"quote": "War calls: will you answer?.",
		"author": ""
	},
	{
		"quote": "Weigh the fist that strikes men down and salutes the battle won.",
		"author": ""
	},
	{
		"quote": "Welcome the judgement of the Emperor.",
		"author": ""
	},
	{
		"quote": "Without fear or falter, do thy duty.",
		"author": ""
	},
	{
		"quote": "Withstand the winds of chaos, for the Emperor's light shines through.",
		"author": ""
	},
	{
		"quote": "You need understand nothing to do your duty.",
		"author": ""
	},
	{
		"quote": "Your honor is your life. Let none dispute it.",
		"author": ""
	},
	{
		"quote": "In the Emperor's name, let none survive.",
		"author": ""
	},
	{
		"quote": "Beware the alien, the mutant, the heretic.",
		"author": ""
	},
	{
		"quote": "Faith is our shield, and it will not falter.",
		"author": ""
	},
	{
		"quote": "Death is nothing compared to vindication.",
		"author": ""
	},
	{
		"quote": "Fear the fury of the righteous.",
		"author": ""
	},
	{
		"quote": "Strength through unity, unity through faith.",
		"author": ""
	},
	{
		"quote": "No sacrifice is too great for the Emperor.",
		"author": ""
	},
	{
		"quote": "Hatred is the Emperor's greatest gift to humanity.",
		"author": ""
	},
	{
		"quote": "The Emperor's light shall shine upon us all.",
		"author": ""
	},
	{
		"quote": "We are but instruments of the Emperor's will.",
		"author": ""
	},
	{
		"quote": "In death, sacrifice; in sacrifice, victory.",
		"author": ""
	},
	{
		"quote": "The Emperor's wrath is terrible to behold.",
		"author": ""
	},
	{
		"quote": "Blessed are the faithful, for they shall know no fear.",
		"author": ""
	},
	{
		"quote": "The enemy is everywhere, watch for their corruption.",
		"author": ""
	},
	{
		"quote": "Honor the fallen, but do not mourn them.",
		"author": ""
	},
	{
		"quote": "The Emperor's mercy is swift and final.",
		"author": ""
	},
	{
		"quote": "To die in battle is the greatest honor.",
		"author": ""
	},
	{
		"quote": "Purity of purpose is the key to victory.",
		"author": ""
	},
	{
		"quote": "The Emperor protects, but we must also protect ourselves.",
		"author": ""
	},
	{
		"quote": "In the face of adversity, we shall stand firm.",
		"author": ""
	},
	{
		"quote": "Only through sacrifice can we hope to achieve victory.",
		"author": ""
	},
	{
		"quote": "We shall not rest until the Emperor's enemies are vanquished.",
		"author": ""
	},
	{
		"quote": "The Emperor's truth is absolute.",
		"author": ""
	},
	{
		"quote": "The Emperor's will is the only law.",
		"author": ""
	},
	{
		"quote": "There is no place for mercy in the Emperor's justice.",
		"author": ""
	},
	{
		"quote": "Let the heretic's blood flow like a river.",
		"author": ""
	},
	{
		"quote": "Blessed be the weapon that kills the heretic.",
		"author": ""
	},
	{
		"quote": "May the Emperor's light guide us through the darkness.",
		"author": ""
	},
	{
		"quote": "The Emperor's wrath is our strength.",
		"author": ""
	},
	{
		"quote": "Without the Emperor, there is only chaos and destruction.",
		"author": ""
	},
	{
		"quote": "There is no greater honor than to die for the Emperor's cause.",
		"author": ""
	},
	{
		"quote": "May the Emperor's fury rain down upon our enemies.",
		"author": ""
	},
	{
		"quote": "The Emperor is the beacon that guides us through the darkness.",
		"author": ""
	},
	{
		"quote": "In death we find redemption.",
		"author": ""
	},
	{
		"quote": "Victory is life; defeat is death.",
		"author": ""
	},
	{
		"quote": "The galaxy is a harsh and unforgiving place.",
		"author": ""
	},
	{
		"quote": "The path of righteousness is seldom easy.",
		"author": ""
	},
	{
		"quote": "The enemy is legion; we are few.",
		"author": ""
	},
	{
		"quote": "The Imperium endures through faith and sacrifice.",
		"author": ""
	},
	{
		"quote": "We are the defenders of Mankind.",
		"author": ""
	},
	{
		"quote": "The price of freedom is eternal vigilance.",
		"author": ""
	},
	{
		"quote": "The Emperor's will is absolute.",
		"author": ""
	},
	{
		"quote": "The righteous will always prevail.",
		"author": ""
	},
	{
		"quote": "The strong stand against the darkness.",
		"author": ""
	},
	{
		"quote": "Martyrdom is the ultimate sacrifice for the Imperium.",
		"author": ""
	},
	{
		"quote": "The Imperium's enemies are many, but we are unbreakable.",
		"author": ""
	},
	{
		"quote": "Let your faith be your shield and your sword.",
		"author": ""
	},
	{
		"quote": "Purge the heretic, burn the unclean.",
		"author": ""
	},
	{
		"quote": "We fight in the name of the Emperor and the Imperium.",
		"author": ""
	},
	{
		"quote": "The Emperor's light shines on us all.",
		"author": ""
	},
	{
		"quote": "In the face of danger, we stand firm.",
		"author": ""
	},
	{
		"quote": "The Emperor's wrath is our righteous fury.",
		"author": ""
	},
	{
		"quote": "We are the sons and daughters of the Imperium.",
		"author": ""
	},
	{
		"quote": "The weak shall fall to the strong.",
		"author": ""
	},
	{
		"quote": "For the glory of the Imperium, we shall prevail.",
		"author": ""
	},
	{
		"quote": "We are the Emperor's chosen, and our victory is assured.",
		"author": ""
	},
	{
		"quote": "To serve the Imperium is to serve the greater good.",
		"author": ""
	},
	{
		"quote": "The Imperium's strength is our unwavering faith.",
		"author": ""
	},
	{
		"quote": "We are the defenders of the Imperium, and we will not falter.",
		"author": ""
	},
	{
		"quote": "The Emperor's will be done, no matter the cost.",
		"author": ""
	},
	{
		"quote": "For the Imperium, we shall lay down our lives.",
		"author": ""
	},
	{
		"quote": "The Imperium is eternal, and so are its defenders.",
		"author": ""
	},
	{
		"quote": "We are the Emperor's loyal servants, and we shall never waver.",
		"author": ""
	},
	{
		"quote": "The Emperor's light shall guide us to victory.",
		"author": ""
	},
	{
		"quote": "The Imperium is our home, and we will defend it with our lives.",
		"author": ""
	},
	{
		"quote": "Our faith in the Emperor is unbreakable, our resolve unshakable.",
		"author": ""
	},
	{
		"quote": "For the Emperor and the Imperium, we shall triumph over all adversity.",
		"author": ""
	},
	{
		"quote": "We are the Emperor's shield, and the Imperium's sword.",
		"author": ""
	},
	{
		"quote": "Blessed be the martyr who dies in service to the Emperor.",
		"author": ""
	},
	{
		"quote": "In His name, we shall cleanse the galaxy.",
		"author": ""
	},
	{
		"quote": "The Emperor's truth is absolute.",
		"author": ""
	},
	{
		"quote": "The darkness cannot hide from the Emperor's light.",
		"author": ""
	},
	{
		"quote": "To doubt the Emperor is to embrace heresy.",
		"author": ""
	},
	{
		"quote": "In the face of danger, we shall not falter.",
		"author": ""
	},
	{
		"quote": "The Emperor's will is our law.",
		"author": ""
	},
	{
		"quote": "There is no room for mercy in the Emperor's judgement.",
		"author": ""
	},
	{
		"quote": "In the face of adversity, we shall triumph.",
		"author": ""
	},
	{
		"quote": "We shall not rest until the galaxy is cleansed of heresy.",
		"author": ""
	},
	{
		"quote": "The Emperor's glory shines upon us all.",
		"author": ""
	},
	{
		"quote": "Only the Emperor can judge the faithful.",
		"author": ""
	},
	{
		"quote": "Through sacrifice, we shall achieve victory.",
		"author": ""
	},
	{
		"quote": "Our faith is our shield, our duty is our sword.",
		"author": ""
	},
	{
		"quote": "The Emperor's wrath is a fearsome thing to behold.",
		"author": ""
	},
	{
		"quote": "The Imperium shall stand for all eternity.",
		"author": ""
	},
	{
		"quote": "Through the Emperor's guidance, we shall overcome all obstacles.",
		"author": ""
	},
	{
		"quote": "Purge the heretic, cleanse the unclean.",
		"author": ""
	},
	{
		"quote": "The Emperor's blessings are reserved for the faithful.",
		"author": ""
	},
	{
		"quote": "We are but instruments of the Emperor's will.",
		"author": ""
	},
	{
		"quote": "In the face of death, we shall not yield.",
		"author": ""
	},
	{
		"quote": "The Emperor's light illuminates even the darkest corners of the galaxy.",
		"author": ""
	},
	{
		"quote": "The path of righteousness is fraught with peril, but we shall not stray.",
		"author": ""
	},
	{
		"quote": "In the name of the Emperor, we shall purge this world.",
		"author": ""
	},
	{
		"quote": "A moment of laxity spawns a lifetime of heresy.",
		"author": ""
	},
	{
		"quote": "Only in death can we truly serve the Emperor.",
		"author": ""
	},
	{
		"quote": "Heresy grows from idleness.",
		"author": ""
	},
	{
		"quote": "The Emperor's wrath is righteous, and it shall smite the unfaithful.",
		"author": ""
	},
	{
		"quote": "The weak deserve only death.",
		"author": ""
	},
	{
		"quote": "Through sacrifice, we earn our salvation.",
		"author": ""
	},
	{
		"quote": "The faithful need not fear the alien.",
		"author": ""
	},
	{
		"quote": "The Emperor's will is absolute.",
		"author": ""
	},
	{
		"quote": "We are the Emperor's chosen, and our fate is to rule the galaxy.",
		"author": ""
	},
	{
		"quote": "Death to the false Emperor.",
		"author": ""
	},
	{
		"quote": "Blessed is the mind too small for doubt.",
		"author": ""
	},
	{
		"quote": "The Emperor guides our hand, but it is our will that strikes.",
		"author": ""
	},
	{
		"quote": "The price of victory is blood.",
		"author": ""
	},
	{
		"quote": "The Emperor's truth is our shield.",
		"author": ""
	},
	{
		"quote": "The galaxy is our birthright, and we shall claim it through fire and blood.",
		"author": ""
	},
	{
		"quote": "To serve the Emperor is to live with purpose.",
		"author": ""
	},
	{
		"quote": "The Emperor's light shines upon us all, illuminating our path to victory.",
		"author": ""
	},
	{
		"quote": "We are the Imperium's sword, and we shall cut down all who oppose us.",
		"author": ""
	},
	{
		"quote": "The Emperor's foes shall tremble at the sound of our war cry.",
		"author": ""
	},
	{
		"quote": "Through faith, we are made strong.",
		"author": ""
	},
	{
		"quote": "The Emperor's glory is our reward, and we shall earn it through our deeds.",
		"author": ""
	},
	{
		"quote": "Fuck the heretic scum, they deserve to be purged in flames.",
		"author": ""
	},
	{
		"quote": "I long for the sweet release of death in battle, a death worthy of remembrance.",
		"author": ""
	},
	{
		"quote": "The Emperor's justice is a beautiful fucking thing.",
		"author": ""
	},
	{
		"quote": "There is no future without the Emperor's fucking blessing.",
		"author": ""
	},
	{
		"quote": "I will carve the traitors and mutants to pieces with my bare hands.",
		"author": ""
	},
	{
		"quote": "Praise the Emperor, who teaches us to destroy all who oppose us.",
		"author": ""
	},
	{
		"quote": "I will bathe in the blood of the impure and sanctify myself with their screams.",
		"author": ""
	},
	{
		"quote": "The mutant is guileful, trust it not, and kill it with extreme prejudice.",
		"author": ""
	},
	{
		"quote": "Existence is meaningless without the glory of the Emperor to guide us.",
		"author": ""
	},
	{
		"quote": "I'll fucking die before I let anyone defy the will of the Emperor.",
		"author": ""
	},
	{
		"quote": "Thou shalt not yield, and thou shalt crush thy enemies with impunity.",
		"author": ""
	},
	{
		"quote": "I'll smite anyone who dares to question the righteousness of the Emperor.",
		"author": ""
	},
	{
		"quote": "Blessed be the slaughterer of heretics, for he shall reap the rewards of eternal damnation.",
		"author": ""
	},
	{
		"quote": "There is no being so foul as the traitor, and they shall know my wrath.",
		"author": ""
	},
	{
		"quote": "The weak shall be purged, the strong shall endure, and I shall be among the strongest.",
		"author": ""
	},
	{
		"quote": "Thou shalt kill, for the Emperor's will demands it.",
		"author": ""
	},
	{
		"quote": "Only in death does duty end, and I will serve the Emperor until my last breath.",
		"author": ""
	},
	{
		"quote": "Carry your scars with honour, and wear them as a badge of loyalty to the Emperor.",
		"author": ""
	},
	{
		"quote": "Knowledge brings us closer to annihilation, but I welcome the end with open arms.",
		"author": ""
	},
	{
		"quote": "Innocence proves nothing.",
		"author": "The Emperor of Mankind"
	},
	{
		"quote": "Only in death does duty end.",
		"author": "Space Marine Code"
	},
	{
		"quote": "Hope is the first step on the road to disappointment.",
		"author": "Chaos Sorcerer Maxim"
	},
	{
		"quote": "Faith is our shield.",
		"author": "Imperial Guard"
	},
	{
		"quote": "Knowledge is power, hide it well.",
		"author": "Adeptus Mechanicus Maxim"
	},
	{
		"quote": "F**k the weak, they are unworthy of life!",
		"author": "Khorne, God of Blood and Skulls"
	},
	{
		"quote": "Kill them all, let the Emperor sort them out!",
		"author": "Space Marine battle cry"
	},
	{
		"quote": "There is no salvation without sacrifice.",
		"author": "Dark Apostle of Chaos"
	},
	{
		"quote": "The only true loyalty is to the one who wields power.",
		"author": "Chaos Lord"
	},
	{
		"quote": "Death to the false emperor!",
		"author": "Chaos Space Marine chant"
	},
	{
		"quote": "The galaxy is ours for the taking, by force if necessary.",
		"author": "Archon of the Dark Eldar"
	},
	{
		"quote": "Knowledge is a weapon, but wield it carefully or it will destroy you.",
		"author": "Eldar Farseer"
	},
	{
		"quote": "All who oppose us will be crushed beneath the heel of our might.",
		"author": "Ork Warboss"
	},
	{
		"quote": "Only in the face of death do we find our true purpose.",
		"author": "Necron Overlord"
	},
	{
		"quote": "The Imperium is built on lies, deceit, and the blood of the innocent.",
		"author": "Heretic"
	},
	{
		"quote": "Embrace the power of chaos and revel in the destruction it brings.",
		"author": "Chaos Cultist"
	},
	{
		"quote": "We are the true inheritors of the galaxy, and all others must bow before us.",
		"author": "Tyranid Hive Mind"
	},
	{
		"quote": "In the end, only the strong survive. The weak are consumed by the flames of war.",
		"author": "Chaos Champion"
	},
	{
		"quote": "Blasphemy is the greatest sin, and those who commit it shall suffer eternal damnation.",
		"author": "Ecclesiarch of the Imperium"
	},
	{
		"quote": "Knowledge is a curse, for it opens the eyes to the true horrors of the universe.",
		"author": "Inquisitor of the Imperium"
	},
	{
		"quote": "Blood for the blood god, skulls for the skull throne!",
		"author": "Khornate Berserker chant"
	},
	{
		"quote": "Our faith in the Omnissiah shall guide us to victory, no matter the cost.",
		"author": "Adeptus Mechanicus Priest"
	},
	{
		"quote": "The greater the risk, the greater the reward. And we are not afraid to risk everything.",
		"author": "Dark Eldar Haemonculus"
	},
	{
		"quote": "There is no room for mercy in war. Only death and destruction.",
		"author": "Chaos Warlord"
	},
	{
		"quote": "Salvation is for the weak. Only those strong enough to seize power for themselves will survive.",
		"author": "Chaos Lord"
	},
	{
		"quote": "Every damned planet we cleanse brings us one step closer to His vision.",
		"author": "Commander Dante, Blood Angels"
	},
	{
		"quote": "Traitors, heretics, xenos... the galaxy's full of shit that needs purging.",
		"author": "Captain Aethon, Crimson Fists"
	},
	{
		"quote": "In this godforsaken universe, only His divinity keeps our blades sharp and our souls untainted.",
		"author": "Asmodai, Dark Angels Interrogator-Chaplain"
	},
	{
		"quote": "By His sacred wounds, I'll drag every daemon back to the pit from whence they came.",
		"author": "Exorcist Caelus of the Exorcists Chapter"
	},
	{
		"quote": "No curse or heresy shall deter our sacred duty. The Emperor's work is never done.",
		"author": "Inquisitor Kryptman, Ordo Xenos"
	},
	{
		"quote": "By Terra, these damned xenos breed faster than we can kill 'em. But that won't stop us trying.",
		"author": "Colonel Greiss, Valhallan Ice Warriors"
	},
	{
		"quote": "Let them scream, let them curse. Their words die, His words endure.",
		"author": "Saint Celestine, the Living Saint"
	},
	{
		"quote": "Every whisper of heresy, every damned traitor's plot, will be met with chainsword and flame.",
		"author": "Sergeant Torias Telion, Ultramarines"
	},
	{
		"quote": "For every world that falls, ten more will rise, blades drawn in His name.",
		"author": "Logan Grimnar, Great Wolf of the Space Wolves"
	},
	{
		"quote": "These cursed realms hold no terror for those shielded by His might.",
		"author": "Brother Captain Stern, Grey Knights"
	},
	{
		"quote": "Heretics may burn our worlds, but the flame of faith will burn them tenfold.",
		"author": "Warmaster Solar Macharius"
	},
	{
		"quote": "This galaxy's a bloody mess, but it's up to us to mop it up, one battle at a time.",
		"author": "Vulkan He'stan, Salamanders"
	},
	{
		"quote": "They may curse our name, but it's His name they'll scream as we send them to the abyss.",
		"author": "Chaplain Ortan Cassius, Ultramarines"
	},
	{
		"quote": "By His light, we'll scour this galaxy clean of every damned soul that stands against us.",
		"author": "Canoness Seraphina, Adepta Sororitas"
	},
	{
		"quote": "The warp may curse us with visions, but His guidance is the only truth we need.",
		"author": "Farseer Macha, Craftworld Biel-Tan"
	},
	{
		"quote": "The Imperium's foundations are built on sacrifice, and by the Emperor, we'll be damned if it falls.",
		"author": "Lord Castellan Ursarkar E. Creed"
	},
	{
		"quote": "For every curse thrown our way, we return it a hundredfold in bolter fire.",
		"author": "Sergeant Darnath Lysander, Imperial Fists"
	},
	{
		"quote": "We tread where others fear, bringing His wrath to the darkest corners of the damned galaxy.",
		"author": "Kor'Sarro Khan, White Scars"
	},
	{
		"quote": "No fortress, no curse, no abomination can stand in the face of our unyielding faith.",
		"author": "High Marshal Helbrecht, Black Templars"
	},
	{
		"quote": "In a universe of endless war, His word is the only damned peace we've got.",
		"author": "Captain Karlaen, Blood Angels"
	},
	{
		"quote": "The weight of the galaxy may bear down upon us, but in His shadow, we stand tall.",
		"author": "Lord Commander Solar Decius"
	},
	{
		"quote": "Heretics will curse, xenos will lie, but we are His unyielding fist.",
		"author": "Brother-Captain Alaric, Grey Knights"
	},
	{
		"quote": "By His scars, every damned world we retake is a testament to His eternal glory.",
		"author": "Captain Kayvaan Shrike, Raven Guard"
	},
	{
		"quote": "In an age of darkness, only the damned dare defy His light.",
		"author": "Inquisitor Silas Hand, Ordo Hereticus"
	},
	{
		"quote": "There's a special circle in the Warp for traitors, and I'll personally send them there.",
		"author": "Lieutenant Calsius, Ultramarines"
	},
	{
		"quote": "Each bolt round is a prayer, each curse from the enemy a hymn of our impending victory.",
		"author": "Canoness Praxedes, Adepta Sororitas"
	},
	{
		"quote": "For every soul that curses us, a choir in the heavens sings His praises.",
		"author": "Chaplain Grimaldus, Black Templars"
	},
	{
		"quote": "Damnation's tide may rise, but we are the bulwark against the storm.",
		"author": "Commander Shadowsun, T'au Empire, in a rare acknowledgment of the Imperium's resilience"
	},
	{
		"quote": "In the depths of the void, His voice is the only one that matters. Listen, and smite the damned.",
		"author": "Belial, Dark Angels"
	},
	{
		"quote": "This galaxy is filled with monsters, and it's our damned job to put them down.",
		"author": "Lieutenant Nykona Sharrowkyn, Raven Guard"
	},
	{
		"quote": "In His halls, martyrs and heroes dine together. We'll join them, but not before our work is done.",
		"author": "Captain Korvydae, Raven Guard"
	},
	{
		"quote": "Every curse we endure, every wound we suffer, brings us closer to His divine vision.",
		"author": "Uriel Ventris, Ultramarines"
	},
	{
		"quote": "The damned think they own the galaxy, but we're here to collect the Emperor's due.",
		"author": "Marshal Morturg, Death Korps of Krieg"
	},
	{
		"quote": "In the face of treachery, hold firm. His light pierces even the blackest of heresies.",
		"author": "Brother-Captain Artemis, Deathwatch"
	},
	{
		"quote": "We march to the rhythm of bolter fire, and dance to the lamentations of the damned.",
		"author": "Phoenix Lord Asurmen, Dire Avengers"
	},
	{
		"quote": "To challenge us is to challenge Him. Both are fatal errors.",
		"author": "Ephrael Stern, The Heretic Saint"
	},
	{
		"quote": "They can curse our lineage, defile our banners, but His will remains unbroken.",
		"author": "Chief Librarian Mephiston, Blood Angels"
	},
	{
		"quote": "The galaxy may damn us, but in His eyes, our purpose is clear.",
		"author": "Grand Master Azrael, Dark Angels"
	},
	{
		"quote": "Where others see damnation, we see duty. Where others feel fear, we feel His strength.",
		"author": "Vaylund Cal, Iron Hands"
	},
	{
		"quote": "For every step we take in this damned galaxy, we carve His legacy anew.",
		"author": "Sergeant Tor Garadon, Imperial Fists"
	},
	{
		"quote": "A coward's only reward is to live in fear another day",
		"author": ""
	},
	{
		"quote": "A dagger in the dark is worth a thousand swords at dawn",
		"author": ""
	},
	{
		"quote": "A pity it is that we can die but once in the Emperor's service",
		"author": ""
	},
	{
		"quote": "A small mind is a tidy mind",
		"author": ""
	},
	{
		"quote": "A suspicious mind is a healthy mind",
		"author": ""
	},
	{
		"quote": "A swift execution is worth a hundred interrogations",
		"author": ""
	},
	{
		"quote": "Abhor the mutant",
		"author": ""
	},
	{
		"quote": "Abhor the Night, it is the Light that Endures",
		"author": ""
	},
	{
		"quote": "Abhor the xenos",
		"author": ""
	},
	{
		"quote": "Abhorrence is a gift; use it well",
		"author": ""
	},
	{
		"quote": "Aim without mercy",
		"author": ""
	},
	{
		"quote": "Aim true and strike deep",
		"author": ""
	},
	{
		"quote": "All mortal life is folly that does not feed the spirit",
		"author": ""
	},
	{
		"quote": "An informed opinion must be dismissed with the resolute certainty of faith",
		"author": ""
	},
	{
		"quote": "An open mind is like a fortress with its gates unbarred and unguarded",
		"author": ""
	},
	{
		"quote": "Arise for vengeance",
		"author": ""
	},
	{
		"quote": "Be not merciful",
		"author": ""
	},
	{
		"quote": "Be steadfast in defence",
		"author": ""
	},
	{
		"quote": "Be the Emperor's reaper",
		"author": ""
	},
	{
		"quote": "Be thou the scourge of traitors",
		"author": ""
	},
	{
		"quote": "Become righteousness made manifest",
		"author": ""
	},
	{
		"quote": "Become vengeance",
		"author": ""
	},
	{
		"quote": "Beware the corruption of men's souls",
		"author": ""
	},
	{
		"quote": "Beyond the Emperor's light lies only despair",
		"author": ""
	},
	{
		"quote": "Blessed are the intolerant",
		"author": ""
	},
	{
		"quote": "Blessed are the merciless",
		"author": ""
	},
	{
		"quote": "Blessed are they without introspection, for they shall know no doubt",
		"author": ""
	},
	{
		"quote": "Blessed be the slaughterer of heretics",
		"author": ""
	},
	{
		"quote": "Blessed be the subjugator",
		"author": ""
	},
	{
		"quote": "Blessed be the vengeful God, for He is the only true God",
		"author": ""
	},
	{
		"quote": "Blessed be the vengeful",
		"author": ""
	},
	{
		"quote": "Blessed is the mind too small for doubt",
		"author": ""
	},
	{
		"quote": "Blessed be thy aim",
		"author": ""
	},
	{
		"quote": "Blessed be thy fury",
		"author": ""
	},
	{
		"quote": "Blood for the Blood God! Skulls for the Skull Throne",
		"author": ""
	},
	{
		"quote": "By the way of their death shall we know them",
		"author": ""
	},
	{
		"quote": "By your scars and deeds shall you be judged",
		"author": ""
	},
	{
		"quote": "Carry the Will of the Emperor like a torch in the darkness",
		"author": ""
	},
	{
		"quote": "Carry your scars with honour",
		"author": ""
	},
	{
		"quote": "Cleanse the mutant; burn the heretic; purge the xenos",
		"author": ""
	},
	{
		"quote": "Cleave to the Emperor's light",
		"author": ""
	},
	{
		"quote": "Complaining of thy lot is the first step on the Road to Damnation",
		"author": ""
	},
	{
		"quote": "Condemn the damned to their reward",
		"author": ""
	},
	{
		"quote": "Courage is the Emperor's gift",
		"author": ""
	},
	{
		"quote": "Curse the traitor, condemn the weak",
		"author": ""
	},
	{
		"quote": "Death brings peace to the unfaithful",
		"author": ""
	},
	{
		"quote": "Despise the weak, for they shall flock to the call of the renegade",
		"author": ""
	},
	{
		"quote": "Destroy the corruption wherever it is found",
		"author": ""
	},
	{
		"quote": "Do not shy the hopeless fight, for endeavour is its own reward",
		"author": ""
	},
	{
		"quote": "Doubt not the Emperor's wrath",
		"author": ""
	},
	{
		"quote": "Doubt not thy strength whilst faith prevails",
		"author": ""
	},
	{
		"quote": "Duty demands sacrifice",
		"author": ""
	},
	{
		"quote": "Duty first, duty last",
		"author": ""
	},
	{
		"quote": "Duty is vital, understanding is not",
		"author": ""
	},
	{
		"quote": "Emperor guide thy aim",
		"author": ""
	},
	{
		"quote": "Endure the present, so those who follow may continue your endeavours",
		"author": ""
	},
	{
		"quote": "Even the greatest hero is but a ripple on the surface of space",
		"author": ""
	},
	{
		"quote": "Exist for the Emperor",
		"author": ""
	},
	{
		"quote": "Facts are chains that bind perception and fetter truth",
		"author": ""
	},
	{
		"quote": "Faith conquers all",
		"author": ""
	},
	{
		"quote": "Faith needs no excuse",
		"author": ""
	},
	{
		"quote": "Fear not obliteration, for it awaits us all",
		"author": ""
	},
	{
		"quote": "Fear the wrath of the righteous",
		"author": ""
	},
	{
		"quote": "Foolish are those who fear nothing, yet claim to know everything",
		"author": ""
	},
	{
		"quote": "For every enemy without, there are a hundred within",
		"author": ""
	},
	{
		"quote": "Forget not; forgive nothing",
		"author": ""
	},
	{
		"quote": "Forgiveness is a crime punishable by death",
		"author": ""
	},
	{
		"quote": "Forgiveness is punishable by death",
		"author": ""
	},
	{
		"quote": "From duty and death there can be no respite",
		"author": ""
	},
	{
		"quote": "Gird thyself with the Emperor's light",
		"author": ""
	},
	{
		"quote": "Guard Humanity; fear the Enemy Beyond",
		"author": ""
	},
	{
		"quote": "Guard thy soul against disorder",
		"author": ""
	},
	{
		"quote": "Happiness is a delusion of the Weak",
		"author": ""
	},
	{
		"quote": "Hasten the damned to their reward",
		"author": ""
	},
	{
		"quote": "He knows what lies in the darkness, and fears it not",
		"author": ""
	},
	{
		"quote": "Heed not the whispers of the faithless",
		"author": ""
	},
	{
		"quote": "Heed the Word of the Emperor",
		"author": ""
	},
	{
		"quote": "Here be the doom of mutants",
		"author": ""
	},
	{
		"quote": "Here endeth thy lesson",
		"author": ""
	},
	{
		"quote": "Honour the craft of death",
		"author": ""
	},
	{
		"quote": "Honour thy Emperor",
		"author": ""
	},
	{
		"quote": "Honour thy oaths, honour thy Emperor",
		"author": ""
	},
	{
		"quote": "Honour thy regiment",
		"author": ""
	},
	{
		"quote": "Honour thy weapon",
		"author": ""
	},
	{
		"quote": "Honour your duty",
		"author": ""
	},
	{
		"quote": "Honour, duty and obedience",
		"author": ""
	},
	{
		"quote": "Hope is superfluous",
		"author": ""
	},
	{
		"quote": "Hope is the first step on the road to disappointment",
		"author": ""
	},
	{
		"quote": "I bringeth death",
		"author": ""
	},
	{
		"quote": "I speak with tongues of flame",
		"author": ""
	},
	{
		"quote": "If you see no signs of sedition, you aren't looking hard enough",
		"author": ""
	},
	{
		"quote": "Ignorance is thy best defence",
		"author": ""
	},
	{
		"quote": "Imperialis Dominatus",
		"author": ""
	},
	{
		"quote": "Impurity of deed or thought is treason",
		"author": ""
	},
	{
		"quote": "In Terra's light we serve",
		"author": ""
	},
	{
		"quote": "Innocence proves nothing",
		"author": ""
	},
	{
		"quote": "Intolerance is a blessing",
		"author": ""
	},
	{
		"quote": "It is an honour to bleed for the Emperor",
		"author": ""
	},
	{
		"quote": "Justice allows no doubt",
		"author": ""
	},
	{
		"quote": "Keep the faith, kill the foe",
		"author": ""
	},
	{
		"quote": "Kill the heretic with fervour",
		"author": ""
	},
	{
		"quote": "Knowledge brings us closer to annihilation",
		"author": ""
	},
	{
		"quote": "Knowledge is power, guard it well",
		"author": ""
	},
	{
		"quote": "Lack of faith is tantamount to treason",
		"author": ""
	},
	{
		"quote": "Let faith trample reason",
		"author": ""
	},
	{
		"quote": "Let no foe stand before you",
		"author": ""
	},
	{
		"quote": "Let not thy hate be conquered by fear",
		"author": ""
	},
	{
		"quote": "Let thy weapon be zeal, and thy armour contempt",
		"author": ""
	},
	{
		"quote": "Life is fleeting; duty is eternal",
		"author": ""
	},
	{
		"quote": "Life is measured not in years, but by the deeds of the faithful",
		"author": ""
	},
	{
		"quote": "Life is the Emperor's currency, spend it well",
		"author": ""
	},
	{
		"quote": "Mankind stands upon the shoulders of the martyred",
		"author": ""
	},
	{
		"quote": "Mercy is a disease; intolerance is the cure",
		"author": ""
	},
	{
		"quote": "Narrow minds are faithful minds",
		"author": ""
	},
	{
		"quote": "Night descends, yet still the Emperor's light shows the way",
		"author": ""
	},
	{
		"quote": "No man died in the Emperor's service that died in vain",
		"author": ""
	},
	{
		"quote": "Only in death does duty end",
		"author": ""
	},
	{
		"quote": "Only the coward seeks compromise",
		"author": ""
	},
	{
		"quote": "Pass judgement without mercy",
		"author": ""
	},
	{
		"quote": "Persecute, punish, persist",
		"author": ""
	},
	{
		"quote": "Praise be the Emperor, who teaches us the ways of war",
		"author": ""
	},
	{
		"quote": "Praise the Emperor",
		"author": ""
	},
	{
		"quote": "++REDACTED BY ORDER OF THE INQUISITION++",
		"author": ""
	},
	{
		"quote": "Reject peace for the lie that it is",
		"author": ""
	},
	{
		"quote": "Rejoice in repentance",
		"author": ""
	},
	{
		"quote": "Rejoice in thy service",
		"author": ""
	},
	{
		"quote": "Retribution is your birthright",
		"author": ""
	},
	{
		"quote": "Scourge the stars in the Emperor's name",
		"author": ""
	},
	{
		"quote": "Seek for yourself a death worthy of remembrance",
		"author": ""
	},
	{
		"quote": "Slay the impure and sanctify the faithful",
		"author": ""
	},
	{
		"quote": "Smite all who oppose the Emperor",
		"author": ""
	},
	{
		"quote": "Smite all who would besmirch the Emperor's name",
		"author": ""
	},
	{
		"quote": "Speak not the names of traitors",
		"author": ""
	},
	{
		"quote": "Suffer no impurity",
		"author": ""
	},
	{
		"quote": "The difference between heresy and treachery is ignorance",
		"author": ""
	},
	{
		"quote": "The Emperor bears the weight of Mankind's ills",
		"author": ""
	},
	{
		"quote": "The Emperor bestows upon us the gift of intolerance",
		"author": ""
	},
	{
		"quote": "The Emperor commands, the Astra Militarum obeys",
		"author": ""
	},
	{
		"quote": "The Emperor is all",
		"author": ""
	},
	{
		"quote": "The Emperor knows, the Emperor is watching",
		"author": ""
	},
	{
		"quote": "The Emperor protects",
		"author": ""
	},
	{
		"quote": "The Emperor's justice is a beautiful thing",
		"author": ""
	},
	{
		"quote": "The guilt of heresy weighs heavy on the soul",
		"author": ""
	},
	{
		"quote": "The Imperium of Mankind shall never yield",
		"author": ""
	},
	{
		"quote": "The mutant is guileful, trust it not",
		"author": ""
	},
	{
		"quote": "The price of duty is high, but the rewards are eternal",
		"author": ""
	},
	{
		"quote": "The righteous fear naught",
		"author": ""
	},
	{
		"quote": "The same hammer that shatters the glass, forges the steel",
		"author": ""
	},
	{
		"quote": "The seeds of heresy are planted in the minds of the enlightened",
		"author": ""
	},
	{
		"quote": "The shield of faith is your best protection",
		"author": ""
	},
	{
		"quote": "The traitor shall burn",
		"author": ""
	},
	{
		"quote": "The traitor's hand lies closer than you think",
		"author": ""
	},
	{
		"quote": "The truth is terrible to bear",
		"author": ""
	},
	{
		"quote": "The victor lives in honour; the vanquished dies in shame",
		"author": ""
	},
	{
		"quote": "The wage of negligence is utter destruction",
		"author": ""
	},
	{
		"quote": "The weak shall be purged, the strong shall endure",
		"author": ""
	},
	{
		"quote": "The Will of the Emperor is the might of the Imperium",
		"author": ""
	},
	{
		"quote": "The wise have much to fear; the ignorant are blessed with courage",
		"author": ""
	},
	{
		"quote": "The wise learn from the deaths of others",
		"author": ""
	},
	{
		"quote": "There are no walls strong enough to protect the enemies of Mankind",
		"author": ""
	},
	{
		"quote": "There is no being so foul as the traitor",
		"author": ""
	},
	{
		"quote": "There is no fear in conviction",
		"author": ""
	},
	{
		"quote": "There is no future without the Emperor's blessing",
		"author": ""
	},
	{
		"quote": "There is only the Emperor",
		"author": ""
	},
	{
		"quote": "There is purity of purpose in the faith of the just",
		"author": ""
	},
	{
		"quote": "Thou art the hammer of the Emperor",
		"author": ""
	},
	{
		"quote": "Thou shalt be remembered by thy deeds",
		"author": ""
	},
	{
		"quote": "Thou shalt kill",
		"author": ""
	},
	{
		"quote": "Thou shalt not yield",
		"author": ""
	},
	{
		"quote": "Thy hand is justice",
		"author": ""
	},
	{
		"quote": "Timidity begets indecision; indecision begets treachery",
		"author": ""
	},
	{
		"quote": "To err is to invite retribution",
		"author": ""
	},
	{
		"quote": "To relinquish contempt is capitulation",
		"author": ""
	},
	{
		"quote": "To spare the traitor is to invite corruption",
		"author": ""
	},
	{
		"quote": "To question is to doubt",
		"author": ""
	},
	{
		"quote": "To question your master is to betray the Emperor",
		"author": ""
	},
	{
		"quote": "To withdraw in disgust is not apathy",
		"author": ""
	},
	{
		"quote": "Tolerance begets heresy",
		"author": ""
	},
	{
		"quote": "True faith is blind and justified",
		"author": ""
	},
	{
		"quote": "True wisdom is acceptance of the inevitable",
		"author": ""
	},
	{
		"quote": "Trust only the Emperor",
		"author": ""
	},
	{
		"quote": "Truth begets hatred",
		"author": ""
	},
	{
		"quote": "Understanding weakens the will to act",
		"author": ""
	},
	{
		"quote": "Victory belongs to the Emperor",
		"author": ""
	},
	{
		"quote": "Victory needs no explanation; defeat allows none",
		"author": ""
	},
	{
		"quote": "War calls: will you answer?",
		"author": ""
	},
	{
		"quote": "Weigh the fist that strikes men down and salutes the battle won",
		"author": ""
	},
	{
		"quote": "Welcome the judgement of the Emperor",
		"author": ""
	},
	{
		"quote": "Without fear or falter, do thy duty",
		"author": ""
	},
	{
		"quote": "Withstand the winds of chaos, for the Emperor's light shines through",
		"author": ""
	},
	{
		"quote": "You need understand nothing to do your duty",
		"author": ""
	},
	{
		"quote": "Your honor is your life. Let none dispute it",
		"author": ""
	}
];
